// What the two server-paged list tabs, Manage App Adverts and All Apps, share (UN-3339).

export const PAGE_SIZE = 20;

// A new search term starts again from the first page; the same term again (the search box re-fires
// as it debounces) is not a new query, so it returns the query it was given and no fetch follows.
export const searchedFor = (query, fuzzyString) => {
  const search = (fuzzyString || '').trim();
  return search === query.search ? query : { ...query, page: 0, search };
};

// A new sort starts again from the first page too.
export const sortedBy = (query, sort, sortDir) => ({
  ...query,
  page: 0,
  sortBy: sort,
  direction: sortDir ? sortDir.toLowerCase() : null
});
